import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Error, ErrorTemplate } from '@app/home/features/error/models/error.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/error';

  public getErrorTemplates(): Observable<Array<ErrorTemplate>> {
    return this.http.get<Array<ErrorTemplate>>(this.baseUrl + '/template');
  }

  public getErrors(userEmail: string): Observable<Array<Error>> {
    return this.http.get<Array<Error>>(`${this.baseUrl}/${userEmail}`);
  }

  public upsertError(error: Error): Observable<Error> {
    return this.http.post<Error>(this.baseUrl, error);
  }
}
